export const PERMISSIONS = {
  DASHBOARD_ACCESS: 'dashboard:access',
  DASHBOARD_USERS_VIEW: 'dashboard:users:view',
  DASHBOARD_USERS_MANAGE: 'dashboard:users:manage',
  DASHBOARD_QUOTAS_VIEW: 'dashboard:quotas:view',
  DASHBOARD_QUOTAS_MANAGE: 'dashboard:quotas:manage',
  DASHBOARD_STOCKS_VIEW: 'dashboard:stocks:view',
};

export const PERMISSION_LABELS = {
  [PERMISSIONS.DASHBOARD_ACCESS]: 'Accès au tableau de bord',
  [PERMISSIONS.DASHBOARD_USERS_VIEW]: 'Voir les utilisateurs',
  [PERMISSIONS.DASHBOARD_USERS_MANAGE]: 'Gérer les utilisateurs',
  [PERMISSIONS.DASHBOARD_QUOTAS_VIEW]: 'Voir les quotas',
  [PERMISSIONS.DASHBOARD_QUOTAS_MANAGE]: 'Gérer les quotas',
  [PERMISSIONS.DASHBOARD_STOCKS_VIEW]: 'Voir les stocks',
};

export const DEFAULT_PERMISSIONS_BY_ROLE = {
  user: [],
  manager: [],
  technician: [],
  admin: [
    PERMISSIONS.DASHBOARD_ACCESS,
    PERMISSIONS.DASHBOARD_USERS_VIEW,
    PERMISSIONS.DASHBOARD_USERS_MANAGE,
  ],
  superadmin: [
    PERMISSIONS.DASHBOARD_ACCESS,
    PERMISSIONS.DASHBOARD_USERS_VIEW,
    PERMISSIONS.DASHBOARD_USERS_MANAGE,
    PERMISSIONS.DASHBOARD_QUOTAS_VIEW,
    PERMISSIONS.DASHBOARD_QUOTAS_MANAGE,
    PERMISSIONS.DASHBOARD_STOCKS_VIEW,
  ],
};

/**
 * Get default permissions for a role
 * @param {string} role - User role
 * @returns {string[]} Array of permission strings
 */
export const getDefaultPermissions = (role) => {
  return DEFAULT_PERMISSIONS_BY_ROLE[role] || [];
};

/**
 * Get all available permissions as an array
 * @returns {Array<{value: string, label: string}>}
 */
export const getAllPermissions = () => {
  return Object.values(PERMISSIONS).map(permission => ({
    value: permission,
    label: PERMISSION_LABELS[permission] || permission,
  }));
};
